export default {
  name: 'linkTranslator',
  translate(i) {
    if (i.linkController == "group" && i.linkAction == "home") return "/group/" + i.linkId;
    if (i.linkController == "issues" && i.linkAction == "show") return "/issues/show/" + i.linkId;
    if (i.linkController == "conversations") return "/conversations/" + i.linkId;
    if (i.linkController == "group" && i.linkAction == "members") return "/group/" + i.linkId + "/members";
    if (i.linkController == "group" && i.linkAction == "billing") return "/group/" + i.linkId + "/billing";
    if (i.linkController == "event" && i.linkAction == "people") return "/event/show/" + i.linkId + "?view=people";
    if (i.linkController == "groupMember" && i.linkAction == "list") {
      let path = "/group/" + i.groupId + "/members/";
      if (i.linkId.indexOf("=") > -1) {
        let parts = i.linkId.split("=");
        path += parts[1];
      } else path += i.linkId;
      return path;
    }
    if (i.linkController == "event") return "/event/" + i.linkAction + "/" + i.linkId;
    if (i.linkController == "forum") return "/group/" + i.groupId + "/forum/" + i.linkId;

    let dest = i.linkController;
    if (i.linkAction) dest += "/" + i.linkAction;
    if (i.linkId) dest += "/" + i.linkId;
    return dest;
  }
};
